import { $, $$ } from 'utils/dom';

// we have the default darkmode functionality and we have pages that have darkmode as default
// these two modes are seperate
export default class DarkMode {
  constructor(button) {
    this.button = button;
  }

  getAndSetMode = () => {
    const isDefaultDarkmode = $('body').classList.contains(
      'c-body--default-black'
    );

    if (!isDefaultDarkmode) {
      if (localStorage.getItem('theme') === 'dark') {
        $('body').classList.add('c-body--black');
      } else {
        localStorage.setItem('theme', 'light');
      }
    } else if (isDefaultDarkmode) {
      this.button.classList.add('darkmode-switch-btn-on-darkmode');

      if (localStorage.getItem('darkModeTheme') === 'light') {
        $('body').classList.remove('c-body--black');
      } else {
        localStorage.setItem('darkModeTheme', 'dark');
      }
    }
  };

  toggleClassesAndLocalStorage = () => {
    if (this.button) {
      const isPressed = this.button.getAttribute('aria-pressed');
      if (isPressed === 'true') {
        this.button.setAttribute('aria-pressed', 'false');
      } else {
        this.button.setAttribute('aria-pressed', 'true');
      }

      const buttonOnDarkmode = this.button.classList.contains(
        'darkmode-switch-btn-on-darkmode'
      );

      if (!buttonOnDarkmode) {
        $('body').classList.toggle('c-body--black');

        if (localStorage.getItem('theme') === 'light') {
          localStorage.setItem('theme', 'dark');
        } else if (localStorage.getItem('theme') === 'dark') {
          localStorage.setItem('theme', 'light');
        }
      } else if (buttonOnDarkmode) {
        $('body').classList.toggle('c-body--black');

        if (localStorage.getItem('darkModeTheme') === 'light') {
          localStorage.setItem('darkModeTheme', 'dark');
        } else if (localStorage.getItem('darkModeTheme') === 'dark') {
          localStorage.setItem('darkModeTheme', 'light');
        }
      }
    }
  };

  init = () => {
    this.getAndSetMode();

    this.button &&
      this.button.addEventListener('click', () => {
        this.toggleClassesAndLocalStorage();
      });
  };
}

const darkmodeBtn = $$('.darkmode-switch-btn');

if (darkmodeBtn.length) {
  darkmodeBtn.forEach(btn => {
    new DarkMode(btn).init();
  });
}
